// const host = window.location.host
// //* 如果想要在本地调试线上环境，手动取消下面这行代码的注释：
// // const isProd = true;
// const isProd = host === 'www.knowledgesource.cn';
// //! 但一定要在推送代码/打包时改回到上面这行代码！

// const baseUrl = isProd ? 'https://www.knowledgesource.cn' : 'https://zkcx.cxstar.cn'
// const fileUrl = isProd ? 'https://file.knowledgesource.cn' : 'https://file.cxstar.cn'

/** 测试环境 */
// const baseUrl = 'http://192.168.0.146:7080/api/v1';
// const baseUrl = `https://${window.location.host}/api/v1`;
// const baseUrl = 'http://m.duoyuan.cn/api/v1';
const baseUrl = "https://booken.cxstar.cn/api/v1";
const fileUrl = "https://file.cxstar.cn";

const coverapi = "/api/v1/fileredirect/file?ruid=";
export default {
  fileUrl,
  baseUrl,
  coverapi,
  checkIsNotEmpty(val) {
    if (
      val != undefined &&
      val != null &&
      val != "" &&
      val.trim() != "" &&
      val != " "
    ) {
      return true;
    } else {
      return false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/common.js